if (!customElements.get('saza-signature-carousel')) {
  customElements.define('saza-signature-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.saza-signature-carousel__track');
      this.slides = [...this.track.children];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => { this.paused = true; this.go(Number(button.dataset.slide)); }, opts));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.paused = true;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.paused = true; this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, opts);
      this.track.addEventListener('scroll', () => { this.index = Math.round(this.track.scrollLeft / this.track.clientWidth); this.update(); }, opts);
      this.addEventListener('pointerenter', () => this.hovered = true, opts);
      this.addEventListener('pointerleave', () => this.hovered = false, opts);
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.update(); }, opts);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.go(this.index + 1);
      }, 3000);
      this.update();
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth'});
      this.update();
    }
    update() {
      this.querySelectorAll('[data-slide]').forEach(button => button.setAttribute('aria-current', Number(button.dataset.slide) === this.index ? 'true' : 'false'));
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}
